<div class="conversion-bar">
  <div class="from">
    <h3 class="light-type">{{ oldLamp.manufacturer }} {{ oldLamp.model }}</h3>
    <h4 class="count">{{ 'module.energyMap.scenarioPanel.numberText' | translate }}: {{ count }}</h4>
  </div>
  <div class="transition">
    <span class="fa fa-arrow-right"></span>
  </div>
  <div class="to">
    <h3 class="light-type">{{ newLamp.manufacturer }} {{ newLamp.model }}</h3>
    <h4 class="count">{{ 'module.energyMap.scenarioPanel.numberText' | translate }}: {{ count | number: '' : 'es' }}</h4>
  </div>
</div>
